import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Lock, ShieldCheck, Download, FileText, Gift } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
import { CURRENT_PRICE, ORIGINAL_PRICE, DISCOUNT_PERCENT, CHECKOUT_URL } from '../utils/constants';
export function OfferSection() {
  return <section id="comprar" className="bg-navy-900 py-20 md:py-28 relative text-cream-50" data-id="element-213">
      <div className="container mx-auto px-4" data-id="element-214">
        <div className="max-w-[800px] mx-auto" data-id="element-215">
          <FadeIn data-id="element-216">
            <div className="text-center mb-12" data-id="element-217">
              <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-6" data-id="element-218">
                Empieza a mejorar tus noches hoy mismo
              </h2>
              <p className="text-lg text-cream-100/70 max-w-2xl mx-auto" data-id="element-219">
                Acceso inmediato a la guía completa y todos los bonos en formato
                digital.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-220">
            <div className="bg-navy-950 rounded-3xl shadow-2xl border border-gold-500/20 overflow-hidden relative" data-id="element-221">
              {/* Premium glow effect */}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[80%] h-32 bg-gold-500/10 blur-[80px] rounded-full pointer-events-none" data-id="element-222" />

              <div className="p-8 md:p-12" data-id="element-223">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-224">
                  {/* Left Column: Image & Includes */}
                  <div data-id="element-225">
                    <div className="flex justify-center mb-8 relative" data-id="element-226">
                      <div className="absolute inset-0 bg-gold-500/10 blur-2xl rounded-full transform scale-75" data-id="element-227" />
                      <img src="https://cdn.magicpatterns.com/uploads/eVPGx4bf25Dj1a1Lq4KT22/image_(2).png" alt="Protocolo Próstata: Noches en Paz" className="w-full max-w-[280px] rounded-xl shadow-2xl border border-white/5 relative z-10" data-id="element-228" />
                    </div>

                    <div className="space-y-5" data-id="element-229">
                      <h4 className="text-sm font-bold text-gold-400 uppercase tracking-wider" data-id="element-230">
                        Lo que recibes:
                      </h4>

                      {/* Main Guide */}
                      <div data-id="element-231">
                        <div className="flex items-start gap-3 mb-2" data-id="element-232">
                          <FileText className="text-gold-500 shrink-0 mt-0.5" size={18} data-id="element-233" />
                          <span className="text-sm text-cream-100/90 font-semibold" data-id="element-234">
                            Protocolo Próstata: Noches en Paz (PDF)
                          </span>
                        </div>
                        <ul className="ml-8 space-y-1 text-xs text-cream-100/60" data-id="element-235">
                          <li data-id="element-236">• Plan de acción de 72 horas paso a paso</li>
                          <li data-id="element-237">• Lista de los 7 irritantes invisibles</li>
                          <li data-id="element-238">• Técnica de Doble Vaciado</li>
                          <li data-id="element-239">• Hidratación estratégica</li>
                          <li data-id="element-240">• Diario de seguimiento nocturno</li>
                        </ul>
                      </div>

                      {/* Bonus 1 */}
                      <div data-id="element-241">
                        <div className="flex items-start gap-3 mb-2" data-id="element-242">
                          <Gift className="text-gold-500 shrink-0 mt-0.5" size={18} data-id="element-243" />
                          <span className="text-sm text-cream-100/90 font-semibold" data-id="element-244">
                            BONO 1: Plan de Cenas 7 Días
                          </span>
                        </div>
                        <ul className="ml-8 space-y-1 text-xs text-cream-100/60" data-id="element-245">
                          <li data-id="element-246">• Menú de 7 noches sin irritantes</li>
                          <li data-id="element-247">• Recetas rápidas (5-15 min)</li>
                          <li data-id="element-248">• Lista de compras incluida</li>
                          <li data-id="element-249">• Versión bajo en sodio por defecto</li>
                        </ul>
                      </div>

                      {/* Bonus 2 */}
                      <div data-id="element-250">
                        <div className="flex items-start gap-3 mb-2" data-id="element-251">
                          <Gift className="text-gold-500 shrink-0 mt-0.5" size={18} data-id="element-252" />
                          <span className="text-sm text-cream-100/90 font-semibold" data-id="element-253">
                            BONO 2: Guía de Emergencia 3AM
                          </span>
                        </div>
                        <ul className="ml-8 space-y-1 text-xs text-cream-100/60" data-id="element-254">
                          <li data-id="element-255">• Protocolo de 5 pasos si ya te despertaste</li>
                          <li data-id="element-256">• Técnicas para volver a dormir rápido</li>
                          <li data-id="element-257">
                            • Checklist tipo tarjeta para usar medio dormido
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  {/* Right Column: Price & CTA */}
                  <div className="flex flex-col justify-center" data-id="element-258">
                    <div className="mb-8" data-id="element-259">
                      <div className="inline-block bg-gold-500/10 text-gold-400 font-bold text-xs px-3 py-1 rounded-full border border-gold-500/20 mb-4" data-id="element-260">
                        OFERTA ESPECIAL - {DISCOUNT_PERCENT} DTO
                      </div>

                      <div className="flex items-baseline gap-3 mb-2" data-id="element-261">
                        <span className="text-2xl text-cream-100/40 font-bold line-through" data-id="element-262">
                          {ORIGINAL_PRICE}
                        </span>
                        <span className="text-6xl font-bold text-white tracking-tight" data-id="element-263">
                          {CURRENT_PRICE}
                        </span>
                        <span className="text-lg text-cream-100/60 font-medium" data-id="element-264">
                          USD
                        </span>
                      </div>
                      <p className="text-cream-100/50 text-sm" data-id="element-265">
                        Pago único. Sin suscripciones ocultas.
                      </p>
                    </div>

                    <Button href={CHECKOUT_URL} className="w-full text-lg py-5 mb-6 shadow-xl shadow-gold-500/10" onClick={trackAddToCart} data-id="element-266">
                      Descargar guía ahora
                    </Button>

                    <div className="space-y-3" data-id="element-267">
                      <div className="flex items-center gap-2 text-sm text-cream-100/60" data-id="element-268">
                        <Download size={16} className="text-gold-500/70" data-id="element-269" />
                        <span data-id="element-270">Acceso instantáneo a tu correo</span>
                      </div>
                      <div className="flex items-center gap-2 text-sm text-cream-100/60" data-id="element-271">
                        <Lock size={16} className="text-gold-500/70" data-id="element-272" />
                        <span data-id="element-273">Pago 100% seguro y encriptado</span>
                      </div>
                      <div className="flex items-center gap-2 text-sm text-cream-100/60" data-id="element-274">
                        <ShieldCheck size={16} className="text-gold-500/70" data-id="element-275" />
                        <span data-id="element-276">Garantía de satisfacción</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}